import "/src/styles/fonts.css";
import "/src/styles/global.css";
import "/src/styles/navbar.scss";
import "/src/styles/post.scss";
require("prismjs/themes/prism-solarizedlight.css");
require("prismjs/themes/prism-okaidia.css");
